export default __webpack_public_path__ + "images/logoCnn.304e053f20122847b5a9b7d7345ec1a0.svg"